import { render } from "./Movies.vue?vue&type=template&id=75639138&scoped=true"
import script from "./Movies.vue?vue&type=script&lang=js"
export * from "./Movies.vue?vue&type=script&lang=js"

import "./Movies.vue?vue&type=style&index=0&id=75639138&scoped=true&lang=scss"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75639138"]])

export default __exports__